module.exports = __webpack_public_path__ + "static/logo-un@2x-c5300c8c36bc59928fda1a768c98d897.png";